// middleware/authMiddleware.js
import { refreshToken } from "../actions/authActions";

const authMiddleware = (store) => (next) => (action) => {
 
  if (action.type === "LOGIN_USER") {
    const token = action.payload.token;
    if (token === undefined) {
      localStorage.removeItem("token");
    }

    store.dispatch(refreshToken());
    // const userType = store.getState().auth.user.userType;
    const userType = store.getState().auth;
    if (userType === "admin" && action.payload.route === "/admin") {
      // Perform admin-specific actions
    } else if (userType === "user" && action.payload.route === "/user") {
      // Perform user-specific actions
    }else if (userType === "SuperAdmin" && action.payload.route === "/SuperAdmin") { 
    
    }else if (userType==="DatasetAdmin" && action.payload.route === "/DatasetAdmin") {  
    
    }else if (userType==="ExternalUser" && action.payload.route === "/user") {  
    
    }
    else {
      // Unauthorized route, handle accordingly
    }
  } else if (action.type === "LOGOUT_USER") {
    localStorage.removeItem("token");
  }

  return next(action);
};

export default authMiddleware;
